/** @jsxImportSource @emotion/react */
'use client';

import React from 'react';
import { StyledSelect } from './styled';
import type { SelectProps } from './types';

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  (
    {
      variant = 'default',
      size = 'md',
      hasError = false,
      disabled = false,
      fullWidth = true,
      children,
      className,
      testId = 'select',
      css,
      style,
      ...rest
    },
    ref
  ) => {
    return (
      <StyledSelect
        ref={ref}
        $variant={variant}
        $size={size}
        $hasError={hasError}
        $fullWidth={fullWidth}
        disabled={disabled}
        data-testid={testId}
        data-variant={variant}
        data-error={hasError || undefined}
        aria-invalid={hasError || undefined}
        className={className}
        css={css}
        style={style}
        {...rest}
      >
        {children}
      </StyledSelect>
    );
  }
);

Select.displayName = 'Select';
